import React from 'react';
//Material-UI
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
//Context
import { useOrdProd } from './OrdProdContext';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 384,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: 0,
        borderRadius: '0.375rem',
        overflow: 'hidden',
    },
}));

function PopUpS(props) {
    const classes = useStyles();
    const { borrar, setBorrar } = useOrdProd();
    const [modalStyle] = React.useState(getModalStyle);
    

    const handleOpen = () => {
        setBorrar(!borrar);
    };

    const handleClose = () => {
        setBorrar(false);
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            {props.popupBody}
            <div className="popupbottom popupbottom--center">
                <Button
                    variant="outlined"
                    color="primary"
                    className="popup-button-s"
                    onClick={handleClose}
                >
                    {props.popupSeconButton}
                </Button>
                {props.popupPrimAction}
            </div>
        </div>
    );

    return (
        <div>
            <Button
                variant={props.isContained}
                color={props.colorButton}
                className={props.buttonClass}
                disabled={!props.isActive}
                onClick={handleOpen}
            >
                {props.textButton}
            </Button>
            <Modal
                open={borrar}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}

PopUpS.defaultProps = {
    popupTitle: 'Título',
    popupBody: 'Cuerpo de la ventana emergente',
    popupsbclass: 'btn-del-cnl',
    popupSeconButton: 'Cancelar',
    colorButton: 'primary',
    buttonClass: 'btn-guardar',
    textButton: 'Submit',
    isContained: 'contained',
    isActive: true,
    popupPrimAction: null,
};

export default PopUpS;
